import React from 'react';
import { DataContext } from '../DataProvider';

function SearchBar() {
  const { searchTerm, setSearchTerm } = React.useContext(DataContext);
  return (
    <div class='search-wrapper'>
      <input
        type='search'
        placeholder='Search reminders…'
        class='search-input'
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>
  );
}

export default SearchBar;
